export default __webpack_public_path__ + "static/banner-about-us-f11fa5d5d33065ffeed10a46fa5ed9a0.jpg";